import React from "react";
import "../../AllComponentCSS.css";
import CodeCopyBlock from "../../CodeCopyBlock";
import TryItButtonHTML from "../../TryItButtonHTML";
import OutputBox from "../../OutputBox";

export default function Section({ title, html, description, Output }) {
  // If Output is empty or undefined, use html as default output
  const liveOutput = Output && Output.trim() !== "" ? Output : html;

  return (
    <div className="tutorial-section">
      {/* 🔹 Title */}
      <h2 className="section-title">{title}</h2>

      {/* 🔹 Description */}
      <p className="section-description">{description}</p>

      {/* 🔹 Code Block + Try It Button */}
      <div className="code-demo-box read-only-box">
        <CodeCopyBlock code={html} />
        <TryItButtonHTML html={html} />
      </div>

      {/* 🔹 Live Output */}
      <h3 style={{ marginTop: "1rem" }}>Output:</h3>
      <OutputBox>
        <div
          className="output-live"
          dangerouslySetInnerHTML={{ __html: liveOutput }}
          style={{
            padding: "10px",
            background: "#fff",
            color: "#000",
            borderRadius: "8px",
          }}
        />
      </OutputBox>
    </div>
  );
}
